/**
 * This compoment is mainly for controlling devices(drawers).
 */
import _ from 'lodash';
import moment from 'moment';
import Vue from 'vue';
import axios from 'axios';
import server, { TaskWebSocketServer } from '@/config';
import router from '../../router';
import * as Mutations from '../mutation-types';


const state = {
  systemId: undefined,              // 目前此系統於db的id
  systems: {},                      // 此系統若有多藥櫃的話，會用object來儲存layout (抱歉不應該用這麼糟糕的variable name...)
  systemArea: undefined,            // 系統位於的區域
  systemLayoutChecked: false,       // 系統的layout已經檢查過（從local websocket）
  externalCmpn: null,               // 外部藥盒
  currentNetIndex: 0,               // 目前操作(點選)的net index
  currentSystem: {},                // 目前操作中的藥櫃 (抱歉不應該用這麼糟糕的variable name...)
  selectedDevicesID: [],            // 選擇的裝置 IDs
  selectedDevices: {},              // 選擇的裝置資料
  currentDevice: null,              // 目前動作中的裝置
  nextDevice: null,                 // 下一步奏將操作的裝置
  errorDevices: [],                 // 目前藥櫃開啟中的藥盒或抽屜
  allDevices: {},                   // 系統的所有裝置
  forLockDevices: [],               // 上鎖的裝置
};


const mutations = {
  /**
   * Reset all variables.
   */
  [Mutations.RESET_DEVICES_MODULE](state) {
    state.selectedDevicesID = [];
    state.selectedDevices = {};
    state.currentDevice = null; // device working on in the flow.
    state.nextDevice = null;
    state.errorDevices = [];
  },
  /**
   * set current device and next device if possible
   */
  [Mutations.SET_CURRENT_DEVICE_FROM_SELECTED](state, deviceId) {
    // set current device from selectedDevices.
    state.currentDevice = state.selectedDevices[deviceId];

    // set next device for adc control.
    const keys = state.selectedDevicesID;
    const index = keys.indexOf(deviceId.toString());
    if (index < (keys.length - 1) && index !== -1) {
      state.nextDevice = state.selectedDevices[keys[index + 1]];
    } else {
      state.nextDevice = null;
    }
  },
  /**
   * set current device from all devices;
   */
  [Mutations.SET_CURRENT_DEVICE_FROM_ALL](state, deviceId) {
    state.currentDevice = state.allDevices[deviceId];
  },
  [Mutations.SET_NEXT_DEVICE](state, deviceId) {
    state.nextDevice = state.allDevices[deviceId];
  },
  [Mutations.REMOVE_NEXT_DEVICE](state) {
    state.nextDevice = null;
  },
  [Mutations.SET_CURRENT_NET](state, index) {
    state.currentNetIndex = index;
  },
  /**
   * add selected devices from all devices
   */
  [Mutations.ADD_DEVICE_TO_SELECTED_LIST](state, deviceId) {
    // update allDevices
    state.allDevices[deviceId].selected = !state.allDevices[deviceId].selected;
    const index = state.selectedDevicesID.indexOf(deviceId.toString());
    if (index === -1) {
      state.selectedDevices[deviceId] = state.allDevices[deviceId];
    } else {
      // state.selectedDevicesID.splice(index, 1);
      delete state.selectedDevices[deviceId];
    }
    state.selectedDevicesID = Object.keys(state.selectedDevices);
  },
  [Mutations.CHANGE_DEVICE_SELECTED_STATUS](state, deviceId) {
    const targetDevice = state.allDevices[deviceId];
    const sys = state.systems[targetDevice.net.system];
    sys.net_set.forEach((net) => {
      net.selectedDeviceCount = 0;
      net.device_set.forEach((device) => {
        if (device.selected === undefined) device.selected = false; // init
        if (device.id === deviceId) {
          device.selected = !device.selected;
          console.log('clicked device: ', device);
        }
        if (device.selected === true) {
          sys.selectedDeviceCount += 1;
          net.selectedDeviceCount += 1;
        } else {
          sys.selectedDeviceCount -= 1;
        }
      });
    });
  },
  [Mutations.SETUP_LOCKED_DEVICES](state, forLockDevices) {
    state.forLockDevices = forLockDevices;
  },
};

const actions = {
  // 重製藥櫃並且拿取母版序號
  resetAndGetLocalSerialNumber({ dispatch, rootState }) {
    rootState.connectionStatus = false;
    dispatch('submitCommand', {
      command: 'reset',
    });
  },
  // 掃描系統layout
  sendScanLocalLayoutCommand({ dispatch, rootState }) {
    rootState.systemLayoutChecked = false;
    dispatch('submitCommand', {
      command: 'get_layout',
    });
  },
  async initSystem({ dispatch }) {
    await dispatch('getSystemId');
    await dispatch('getSystemInfo');
  },
  // 用母版序號去索取系統ID
  getSystemId({ rootState }) {
    return axios.get(`${server}/api/system/`, { params: { series: rootState.cabinetSerials[0] } })
      .then((res) => {
        state.systemId = res.data.results[0].id;
        rootState.connectionStatus = true;
      });
  },
  // init attribute for view usage.
  getSystemInfo({ state, commit, rootState }) {
    rootState.apps.management.functions.lockBox.ready = false;
    return axios.get(`${server}/api/system/${state.systemId}/`)
      .then((res) => {
        let systemCount = 1;
        state.systems = {}; // for child cabinets. sorry for the misleading variable name...
        state.systemArea = res.data.area;
        state.currentSystem = res.data;
        // 其他子藥櫃會用各自的板子序號當作key, 放置各自的資料
        state.systems[res.data.series] = Object.assign({}, res.data);
        state.systems[res.data.series].net_set = [];
        state.systems[res.data.series].relative_index = systemCount;

        rootState.generalSetting = res.data.settings;
        rootState.generalSetting.return_reason = res.data.settings.return_reason.split(';');

        // if the setting of return drug to original device is true, then we do not need to show 'recycleDrug' and 'setReturnBox' app
        rootState.apps.management.functions.recycleDrug.privilege = !rootState.generalSetting.return_to_original_cmpn;
        rootState.apps.setting.functions.setReturnBox.privilege = !rootState.generalSetting.return_to_original_cmpn;

        state.currentSystem.net_set.forEach((net) => {
          // net.selectedDeviceCount = 0;
          if (state.systems[net.system_serial] === undefined) {
            state.systems[net.system_serial] = {};
            state.systems[net.system_serial].net_set = [];
            state.systems[net.system_serial].relative_index = systemCount + 1;
            systemCount += 1;
          }
          state.systems[net.system_serial].net_set.push(net);
          net.hasDeviceSelected = false;
          net.show_row = false;
          let deviceCount = 0;
          net.device_set.forEach((device) => {
            device.selected = false;
            device.index = deviceCount;
            device.drugstorage_set.forEach((item) => {
              item.selected = false;
              const itemExpiredDate = moment(item.expired_date);
              const today = moment();
              const remainDays = itemExpiredDate.diff(today, 'days');
              item.expired = remainDays < 0; // https://eslint.org/docs/rules/no-unneeded-ternary
            });
            state.allDevices[device.id] = device;
            deviceCount += 1;
          });
        });
        rootState.apps.management.functions.lockBox.ready = true;
      });
  },
  /**
   * open drawer or device from state.currentDevice
   * @param {*} param0 vuex attribute
   */
  openDevice({ state, dispatch, rootState }, id) {
    let targetDevice;
    if (id !== undefined) {
      targetDevice = state.allDevices[id];
    } else {
      targetDevice = state.allDevices[state.currentDevice.id];
    }
    dispatch('submitCommand', {
      command: 'open_box',
      appendData: [targetDevice.net.system_serial, targetDevice.net.row_id, targetDevice.pos_row, targetDevice.pos_col],
    });
  },
  /**
   * clean out selected device in current system and reset selected item in current system.
   * @param {*} param0 vuex attribute
   */
  emptyDevices({ state, getters }) {
    state.selectedDevicesID = [];
    state.selectedDevices = {};
    getters.currentSystem.net_set.forEach((net) => {
      net.device_set.forEach((item) => {
        item.selected = false;
      });
    });
  },
};


const getters = {
  selectedDevices: (state, getters) => {
    return Object.entries(state.selectedDevices);
  },
  currentSystem: (state, getters) => {
    return state.currentSystem;
  },
  currentDevice: (state, getters) => {
    return state.currentDevice;
  },
  systems: (state, getters) => {
    return state.systems;
  },
  currentNetIndex: (state, getters) => {
    return state.currentNetIndex;
  },
  allDevices: (state, getters) => {
    return state.allDevices;
  },
};

const store = {
  state,
  mutations,
  actions,
  getters,
};

export default store;



// WEBPACK FOOTER //
// ./src/vuex/module/devices.js